import axiosIns from "@/api/axios";

export const GET_ALL_DATA = (args) => {
  return axiosIns.get(`vendor?${args}`);
};

export const ADD_DATA = (args) => {
  return axiosIns.post(`ideation/${args.id}/rfi/create`, args);
};

export const ADD_VENDOR = (args) => {
  return axiosIns.post(`vendor/create`, args);
};

export const DELETE_VENDOR = (id) => {
  return axiosIns.delete(`rfi/delete/vendor/${id}`);
};

export const CHECK_RFI_CODE = (code) => {
  return axiosIns.get(`ideation/check-rfi?rfi_code=${code}`);
};

export const SUBMIT_RFI_VENDOR = (args) => {
  return axiosIns.put(`ideation/submit-rfi?rfi_code=${args.code}`, args);
}